import { createContext, useContext } from 'react'
import type { User, Organization, ImpersonatingAdmin } from '@/lib/api'

type AuthContextType = {
  user: User | null
  organization: Organization | null
  isLoading: boolean
  isAuthenticated: boolean
  impersonatingAdmin: ImpersonatingAdmin | null
  impersonationExpiresAt: string | null
  login: (email: string, password: string, totpCode?: string) => Promise<void>
  register: (name: string, email: string, password: string) => Promise<void>
  logout: () => Promise<void>
  refreshAuth: () => Promise<Organization | null>
}

export const AuthContext = createContext<AuthContextType | null>(null)

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
